import { render } from "./growCard.vue?vue&type=template&id=882368ca&scoped=true"
import script from "./growCard.vue?vue&type=script&lang=js"
export * from "./growCard.vue?vue&type=script&lang=js"

import "./growCard.vue?vue&type=style&index=0&id=882368ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-882368ca"]])

export default __exports__